var React = require('react');

function InfoCenter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"evenodd","d":"M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm1.389 5.612c-.95 0-1.444.817-1.444 1.425.019.741.399 1.178 1.064 1.178.836 0 1.444-.722 1.444-1.482 0-.589-.342-1.121-1.064-1.121zm.494 10.032c-.551.494-1.045.76-1.216.76-.133 0-.19-.19-.057-.741l1.083-4.408c.266-1.14.171-1.881-.38-1.881-.684 0-2.09.741-3.458 2.014l.266.532c.456-.342.988-.665 1.159-.665.114 0 .095.19 0 .665l-.988 4.256c-.399 1.672.019 2.052.57 2.052.57 0 1.995-.608 3.344-2.09l-.323-.494z"}));
}

InfoCenter.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = InfoCenter;

InfoCenter.default = InfoCenter;
